import { ScatterplotLayer } from '@deck.gl/layers';
import { AirportKey } from '../data/airports';
import { DocumentedAirportProps } from '../data/documentedAirports';
import { DeckState } from '../typings';
import { deselectDuration, locationStartRadius } from '../constants';

export const airportLayer = (
  airports: DocumentedAirportProps[],
  activeAirportKey: AirportKey,
  deckState: DeckState,
) => {
  return new ScatterplotLayer<DocumentedAirportProps>({
    id: 'airport-layer',
    data: airports,
    stroked: true,
    filled: true,
    lineWidthMinPixels: 2,
    getPosition: d => [d.location.longitude, d.location.latitude],
    getRadius: d => {
      switch (deckState) {
        case 'selected':
          if (d.location.key === activeAirportKey) {
            return d.location.radius || 2000;
          }
          break;
      }
      return locationStartRadius;
    },

    // @ts-ignore
    getLineWidth: d => {
      return 200;
    },

    getFillColor: d => {
      switch (deckState) {
        case 'selected':
          if (d.location.key === activeAirportKey) {
            return [100, 255, 200, 50];
          }
          break;
      }
      return [200, 200, 0, 200];
    },

    getLineColor: d => {
      switch (deckState) {
        case 'selected':
          if (d.location.key === activeAirportKey) {
            return [100, 255, 200, 50];
          }
          break;
      }
      return [200, 200, 0, 100];
    },

    // transitions
    transitions: {
      getRadius: {
        duration: deselectDuration,
      },
      getFillColor: {
        duration: deselectDuration,
      },
    },

    //@ts-ignore
    updateTriggers: {
      getRadius: [activeAirportKey, deckState],
      getFillColor: [activeAirportKey, deckState],
    },
  });
};
